"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var Typography = function Typography(_ref) {
  var element = _ref.element,
      type = _ref.type,
      className = _ref.className,
      margins = _ref.margins,
      other = _objectWithoutProperties(_ref, ["element", "type", "className", "margins"]);

  var T = element;
  return _react2.default.createElement(T, _extends({
    className: (0, _classnames2.default)("mdc-typography--" + type, {
      "mdc-typography--no-margins": !margins
    }, className)
  }, other));
};

Typography.propTypes = {
  /** The element type to render (h1, h2, etc.) */
  element: _propTypes.string,

  /** The MDC type  */
  type: (0, _propTypes.oneOf)(["headline1", "headline2", "headline3", "headline4", "headline5", "headline6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline"]),

  /** Custom CSS class */
  className: _propTypes.string,

  /** Remove margins */
  margins: _propTypes.bool
};
Typography.defaultProps = {
  element: "div",
  type: "body1",
  margins: false
};
exports.default = Typography;